/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdAdditionalDataMutationRequest,
  PutApiV1PersonIdAdditionalDataMutationResponse,
  PutApiV1PersonIdAdditionalDataPathParams,
  PutApiV1PersonIdAdditionalData400,
  PutApiV1PersonIdAdditionalData401,
  PutApiV1PersonIdAdditionalData404,
  PutApiV1PersonIdAdditionalData500,
} from "../../types/personRegisterController/PutApiV1PersonIdAdditionalData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdAdditionalData } from "../../clients/personRegisterController/putApiV1PersonIdAdditionalData.ts";

export const putApiV1PersonIdAdditionalDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/additional-data" }] as const;

export type PutApiV1PersonIdAdditionalDataMutationKey = ReturnType<
  typeof putApiV1PersonIdAdditionalDataMutationKey
>;

export function putApiV1PersonIdAdditionalDataMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1PersonIdAdditionalDataMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1PersonIdAdditionalDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdAdditionalDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAdditionalData400
      | PutApiV1PersonIdAdditionalData401
      | PutApiV1PersonIdAdditionalData404
      | PutApiV1PersonIdAdditionalData500
    >,
    {
      id: PutApiV1PersonIdAdditionalDataPathParams["id"];
      data?: PutApiV1PersonIdAdditionalDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdAdditionalData(id, data, config);
    },
  });
}

/**
 * @description Atualiza parcialmente os dados adicionais de uma pessoa. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados adicionais (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/additional-data}
 */
export function usePutApiV1PersonIdAdditionalData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdAdditionalDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdAdditionalData400
        | PutApiV1PersonIdAdditionalData401
        | PutApiV1PersonIdAdditionalData404
        | PutApiV1PersonIdAdditionalData500
      >,
      {
        id: PutApiV1PersonIdAdditionalDataPathParams["id"];
        data?: PutApiV1PersonIdAdditionalDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdAdditionalDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdAdditionalDataMutationKey();

  const baseOptions = putApiV1PersonIdAdditionalDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdAdditionalDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAdditionalData400
      | PutApiV1PersonIdAdditionalData401
      | PutApiV1PersonIdAdditionalData404
      | PutApiV1PersonIdAdditionalData500
    >,
    {
      id: PutApiV1PersonIdAdditionalDataPathParams["id"];
      data?: PutApiV1PersonIdAdditionalDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdAdditionalDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAdditionalData400
      | PutApiV1PersonIdAdditionalData401
      | PutApiV1PersonIdAdditionalData404
      | PutApiV1PersonIdAdditionalData500
    >,
    {
      id: PutApiV1PersonIdAdditionalDataPathParams["id"];
      data?: PutApiV1PersonIdAdditionalDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdAdditionalDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAdditionalData400
      | PutApiV1PersonIdAdditionalData401
      | PutApiV1PersonIdAdditionalData404
      | PutApiV1PersonIdAdditionalData500
    >,
    {
      id: PutApiV1PersonIdAdditionalDataPathParams["id"];
      data?: PutApiV1PersonIdAdditionalDataMutationRequest;
    },
    TContext
  >;
}
